import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["content", "close"];
  private lastActiveElement: HTMLElement | null = null;

  connect() {
    document.querySelector("body")?.classList.add("puts-dialog-is-open-body");
    document.addEventListener("keydown", this.eventCloseKeydown);
  }
  disconnect() {
    document
      .querySelector("body")
      ?.classList.remove("puts-dialog-is-open-body");

    document.removeEventListener("keydown", this.eventCloseKeydown);
  }
  contentTargetConnected(target: HTMLElement) {
    this.lastActiveElement = document.activeElement as HTMLElement;
    target.setAttribute("tabindex", "-1");
    target.focus();
  }
  closeTargetConnected(target: HTMLElement) {
    target.addEventListener("click", this.eventCloseClick);
  }
  closeTargetDisconnected(target: HTMLElement) {
    target.removeEventListener("click", this.eventCloseClick);
  }

  public close() {
    this.lastActiveElement?.focus();
    this.element.remove();
  }

  private eventCloseClick = (event: PointerEvent) => {
    event.preventDefault();
    this.close();
  };
  private eventCloseKeydown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      event.preventDefault();
      this.close();
    }
  };
}
